import { render, staticRenderFns } from "./FeeApplyTurnEdit.vue?vue&type=template&id=4813070c"
import script from "./FeeApplyTurnEdit.vue?vue&type=script&lang=js"
export * from "./FeeApplyTurnEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports